import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Menu from "./Menu";

const Navbar = ({ toggleDrawer, routes }) => {

  return (
    <SNavbar>
      <DrawerButton onClick={toggleDrawer} >
        <i className={toggleDrawer ? "fas fa-bars" : "fas fa-times"} ></i>
      </DrawerButton>

      <NavContainer >
        <RightNav >
          <NavRoutes >
            {routes.map((route) => {
              if (route.subRoutes) {
                return <Menu route={route} key={route.name} />;
              }
              return (
                <NavRoute to={route.link} key={route.name} >
                  {route.name}
                </NavRoute>
              );
            })}
          </NavRoutes>
        </RightNav>
      </NavContainer>
    </SNavbar>
  );
};

export default Navbar;

const DrawerButton = styled.div`
 display: none;
 @media screen and (max-width: 768px){
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 3rem;
    cursor: pointer;
    width: 30px;
    height: 10px;
    color: var(--white);
  }
`;

const SNavbar = styled.nav`
  background-color: var(--white);
`;

const NavContainer = styled.div`
  padding: 1rem;
  height: 50px;
  max-width: 1300px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  color: var(--white);
  justify-content: flex-start;
  background-color:var(--brown);
   
  @media screen and (max-width: 768px) {
    align-items: flex-start;  
  }
`;

const RightNav = styled.div`
  display: flex;
  gap: 2rem;
`;

const NavRoutes = styled.div`
 
@media screen and (max-width: 768px) {
    display: none;
  }

  display: flex;
  justify-content: flex-start;
  gap: 2rem;
  font-size: 20px;
  align-items: center;
`;

// NAVBAR WITHOUT DROPDOWN
const NavRoute = styled(Link)`
  text-decoration: none;
  color: var(--white);
  padding: 0.5rem;
  font-size: 20px;
  transition: all 0.5s ease;

  &:hover {
    transition: all 0.2s ease-out;
    color: var(--brown);
    background-color: var(--white);
    box-shadow: 0px 0px 10px white;
    border-radius: 5px;
  }

 @media screen and (max-width: 1200px) {
     font-size: 20px;
     white-space: nowrap;
  }
  `;